import { createFileRoute } from "@tanstack/react-router";
import AdminProductReviews from "@/pages/admin/AdminProductReviews";

export const Route = createFileRoute("/_adminLayout/admin/parts/reviews")({
  component: AdminProductReviews,
});
